import { render, staticRenderFns } from "./GiftInviteModal.vue?vue&type=template&id=2bb4dbf6&scoped=true&"
import script from "./GiftInviteModal.vue?vue&type=script&lang=js&"
export * from "./GiftInviteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4dbf6",
  null
  
)

export default component.exports